// MBL-3017: Store all relevant analytical data for listing page views
export class ListingPageView {
    listingId: string;
    source: string;
    mlsNum?: string;
    agentPersonifyId?: string;
    agentFirstName?: string;
    agentLastName?: string;
    agentEmail?: string;
    coAgentPersonifyId?: string;
    coAgentFirstName?: string;
    coAgentLastName?: string;
    coAgentEmail?: string;
    uaid?: string;
    uuaid?: string;
    viewedOn: string;
    detailUrl: string;
    clientIPAddress?: string;
    isOffMarket?: boolean;
}
